import { gql } from "@apollo/client";
import { fragments as hddOrderStatusFragments } from "../../application/apps/HDDPressApp/components/HDDOrderStatus/graph";

const markOrderAsHighDefinitionDigitalLocatedMutation = gql`
  mutation ($orderId: ID!) {
    markOrderAsHighDefinitionDigitalLocated(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...HDDOrderStatus_order
      }
      succeeded
    }
  }
  ${hddOrderStatusFragments.order}
`;

export default markOrderAsHighDefinitionDigitalLocatedMutation;
